import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { useCallback, useMemo, useState } from 'react';

import { HelpMenuIcon } from './icon.tsx';

export interface HelpMenuItem {
  title: string;
  link: string;
}

interface HelpMenuProps {
  config: HelpMenuItem[];
}

const StyledHelpIconButton = styled(IconButton)`
  height: auto;
  padding: ${({ theme }) => theme.spacing(1)};
  width: auto;

  &:hover {
    background-color: transparent;
  }
`;

const StyledLinkA = styled('a')`
  color: inherit;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};

  &:hover {
    color: inherit;
  }

  &:visited {
    color: inherit;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  min-width: 150px;
`;

/**
 * @deprecated - Please use the [HelpMenu (v2)](../../Layout/components/HelpMenu.tsx) instead.
 */
export function HelpMenu({ config }: HelpMenuProps) {
  const [optionsAnchor, setOptionsAnchor] = useState<Element | undefined>();

  const closeMenu = useCallback(() => {
    setOptionsAnchor(undefined);
  }, []);
  const onOptionsExpand = (event): void => setOptionsAnchor(event.currentTarget);

  const optionsItems = useMemo(
    () =>
      config.map(({ title, link }, key) => {
        return (
          <StyledMenuItem onClick={closeMenu} key={key} data-test="menu-item">
            <StyledLinkA href={link} target="_blank" rel="noreferrer">
              {title}
            </StyledLinkA>
          </StyledMenuItem>
        );
      }),
    [config, closeMenu]
  );

  return (
    <>
      <StyledHelpIconButton
        onClick={onOptionsExpand}
        disableRipple
        disableFocusRipple
        data-test="help-menu"
        size="large"
      >
        <HelpMenuIcon />
      </StyledHelpIconButton>
      <Menu
        open={!!optionsAnchor}
        anchorEl={optionsAnchor}
        onClose={closeMenu}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        slotProps={{
          list: { disablePadding: true },
        }}
      >
        {optionsItems}
      </Menu>
    </>
  );
}
